import { AllowedMimeType } from '@/components/modules/Documentation/components/DocumentationDetails/components/UploadFileManager/types/AllowedMimeType';

export const getMimeTypeIconNameByType = (mimeType) => {
  switch (mimeType) {
    case AllowedMimeType.IMAGE_JPEG:
    case AllowedMimeType.IMAGE_JPG:
    case AllowedMimeType.IMAGE_PNG:
      return 'image';
    case AllowedMimeType.APPLICATION_JSON:
    case AllowedMimeType.APPLICATION_PDF:
      return 'insert_drive_file';
    default:
      return 'insert_drive_file';
  }
};
